import { deleteAdminUser } from '@common/api/account';
import { useNotificationsStore } from '@common/store/notifications';
import { RPGUsersQueryKeys } from '@common/types/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useDeleteAdminUser = () => {
  const { addNotification } = useNotificationsStore();
  const queryClient = useQueryClient();

  const {
    mutate,
    isPending: isLoading,
    isSuccess
  } = useMutation({
    mutationFn: (payload: number) => {
      return deleteAdminUser(payload);
    },
    onSuccess: () => {
      addNotification('success', 'User delete successfully');
      queryClient.invalidateQueries({ queryKey: [RPGUsersQueryKeys.GET_ADMIN_USER_LIST] });
    },
    onError: () => {
      addNotification('fail', 'Failed to delete User');
    }
  });

  return {
    deleteAdminUser: mutate,
    isLoading,
    isSuccess
  };
};
